module.exports = __webpack_public_path__ + "img/thumbnail_ScimitarHornedOryx_f_normal.c9ee9e92.png";